<template>
    <div i="jd-city-comp" v-if="show" @touchmove.prevent>
        <div class="yd-mask jd-mask" :class="{'mask-show': show}" @click="close()" @touchmove.prevent></div>
        <div class="m-cityselect brouce-in" @touchstart.stop @touchmove.stop>
            <div class="cityselect-header">
                <p class="cityselect-title">请选择省市区</p>
                <div class="cityselect-nav">
                    <a href="javascript:;" :class="{crt: now_idx == 0}" @click="now_idx=0;showNext=0;">{{province_name ? province_name : '请选择'}}</a>
                    <a href="javascript:;" :class="{crt: now_idx == 1}" @click="now_idx=1;showNext=1;">{{city_name}}</a>
                    <a href="javascript:;" :class="{crt: now_idx == 2}" @click="now_idx=2;showNext=2;">{{area_name}}</a>
                    <a href="javascript:;" :class="{crt: now_idx == 3}" @click="now_idx=3;showNext=2;">{{town_name}}</a>
                </div>
            </div>
            <ul class="cityselect-content cityselect-move-animate" :class="{'cityselect-prev': showNext < 1, 'cityselect-next': showNext < 2, 'cityselect-last': showNext == 2}">
                <!-- 省 -->
                <li class="cityselect-item">
                    <div class="cityselect-item-box">
                        <a href="javascript:;" :data-id="item.v" @click="selectItem(index, 2)" :class="{crt: province_id == item.v}" v-for="(item, index) in province">
                            <span>{{item.n}}</span>
                        </a>
                    </div>
                </li>
                <!-- 市 -->
                <li class="cityselect-item">
                    <div class="cityselect-item-box">
                        <a href="javascript:;" :data-id="item.v" @click="selectItem(index, 3)" :class="{crt: city_id == item.v}" v-for="(item, index) in city">
                            <span>{{item.n}}</span>
                        </a>
                    </div>
                </li>
                <!-- 区 -->
                <li class="cityselect-item">
                    <div class="cityselect-item-box">
                        <a href="javascript:;" :data-id="item.v" @click="selectItem(index, 4, 1)" :class="{crt: area_id == item.v}" v-for="(item, index) in area">
                            <span>{{item.n}}</span>
                        </a>
                    </div>
                </li>
                <!-- 区 -->
                <li class="cityselect-item">
                    <div class="cityselect-item-box">
                        <a href="javascript:;" :data-id="item.v" @click="selectItem(index, 5)" :class="{crt: town_id == item.v}" v-for="(item, index) in town">
                            <span>{{item.n}}</span>
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "../assets/sass/common/tool";
[i="jd-city-comp"] {
    .jd-mask {
        position: fixed;
        bottom: 0;
        left: 0;
        top: 0;
        right: 0;
        &.mask-show {
            z-index: 1500;
            background-color: rgb(0, 0, 0);
            opacity: 0.5;
            pointer-events: auto;
        }
    }
    .m-cityselect {
        z-index: 1501;
    }
    .cityselect-last {
        -webkit-transform: translate(-100%);
        transform: translate(-100%);
    }
    .cityselect-item-box {
        height: auto;
    }
    .cityselect-title {
        font-size: pxTorem(14px);
    }
    .cityselect-nav > a {
        font-size: pxTorem(14px);
    }
    .cityselect-item-box > a {
        font-size: pxTorem(14px);
    }
}
</style>
<script>
export default {
    data() {
        return {
            province: [],
            city: [],
            area: [],
            town: [],
            province_name: '',
            city_name: '',
            area_name: '',
            town_name: '',
            province_id: 0,
            city_id: 0,
            area_id: 0,
            town_id: 0,
            showNext: 0,
            now_idx: 0,
        }
    },
    props: ['show', '_province', '_provinceId', '_city', '_cityId', '_area', '_areaId', '_town', '_townId', 'isShowOverseas'],
    computed: {

    },
    methods: {
        //byclick: 1为通过点击，默认为0
        selectItem: function(idx, level, byclick) {
            var that = this;
            var obj = {};

            // 点击省
            if (level == 2) {
                obj = that.province[idx];
                that.province_id = obj.v;
                that.province_name = obj.n;
                that.city_name = '';
                that.area_name = '';
                that.town_name = '';
                if (that.province_id === -1) {
                    that.$emit('callback', {
                        itemName1: that.province_name || '',
                        itemName2: that.city_name || '',
                        itemName3: that.area_name || '',
                        itemName4: that.town_name || '',
                        itemValue1: that.province_id || '',
                        itemValue2: that.city_id || '',
                        itemValue3: that.area_id || '',
                        itemValue4: that.town_id || ''
                    })
                    that.close();
                    return
                }
            }
            // 点击市
            else if (level == 3) {
                obj = that.city[idx];
                that.city_id = obj.v;
                that.city_name = obj.n;
                that.now_idx = 1;
                that.area_name = '';
                that.town_name = '';
            }
            // 点击区
            else if (level == 4) {
                obj = that.area[idx];
                that.area_id = obj.v;
                that.area_name = obj.n;
                that.now_idx = 2;
                that.town_name = '';
                if (that.isShowOverseas) {
                    that.$emit('callback', {
                        itemName1: that.province_name || '',
                        itemName2: that.city_name || '',
                        itemName3: that.area_name || '',
                        itemName4: that.town_name || '',
                        itemValue1: that.province_id || '',
                        itemValue2: that.city_id || '',
                        itemValue3: that.area_id || '',
                        itemValue4: that.town_id || ''
                    });
                    that.close();
                    return;
                }
            }
            // 点击镇
            else if (level == 5) {
                obj = that.town[idx];
                that.town_id = obj.v;
                that.town_name = obj.n;
                that.now_idx = 3;
            }
            that.getJdAreas(level, obj.v, byclick);
        },
        // 京东地址
        getJdAreas: function(level, parent_id, byclick) {
            var that = this, ajaxData = {};
            level = level || 1;
            if (level == 5) {
                that.$emit('callback', {
                    itemName1: that.province_name || '',
                    itemName2: that.city_name || '',
                    itemName3: that.area_name || '',
                    itemName4: that.town_name || '',
                    itemValue1: that.province_id || '',
                    itemValue2: that.city_id || '',
                    itemValue3: that.area_id || '',
                    itemValue4: that.town_id || ''
                });
                that.close();
                return
            }
            ajaxData.level = level;
            if (ajaxData.level != 1 && parent_id) {
                ajaxData.parent_id = parent_id;
            }

            tools.alert.loading();
            tools.ajax({
                url: '/api/get/jd/area',
                ajaxData: ajaxData,
                successFun: function(res) {
                    tools.alert.closeLoading();
                    if (!res.list && byclick) {
                        that.$emit('callback', {
                            itemName1: that.province_name || '',
                            itemName2: that.city_name || '',
                            itemName3: that.area_name || '',
                            itemName4: level == 4 ? '' : that.town_name,
                            itemValue1: that.province_id || '',
                            itemValue2: that.city_id || '',
                            itemValue3: that.area_id || '',
                            itemValue4: level == 4 ? '' : that.town_id
                        });
                        that.close();
                    }
                    let tmpArr = [];
                    /* for (let i = 0; i < res.list.length; i++) {
                        tmpArr.push({
                            v: res.list[i].id,
                            n: res.list[i].name
                        })
                    } */
                    for (const i in res.list) {
                        tmpArr.push({
                            v: res.list[i].id,
                            n: res.list[i].name
                        })
                    }
                    if (level == 1) {
                        if (that.isShowOverseas) {
                            tmpArr.push({
                                v: -1,
                                n: '海外'
                            })
                        }
                        that.province = tmpArr;
                        // that.province.splice(that.province.length);
                        that.showNext = 0;
                    } else if (level == 2) {
                        that.city = tmpArr;
                        that.city.splice(that.city.length);
                        that.showNext = 0;
                    } else if (level == 3) {
                        that.area = tmpArr;
                        that.area.splice(that.area.length);
                        that.showNext = 1;
                    } else if (level == 4) {
                        that.town = tmpArr;
                        that.town.splice(that.town.length);
                        that.showNext = 2;
                    }
                },
                errorFun: function(error_data, status, headers, error_obj) {
                    tools.alert.closeLoading();
                    tools.alert.error(error_data.error_msg);
                },
                type: 'GET'
            });

        },
        close: function() {
            this.$emit('update:show', false);
        }
    },
    components: {},
    filters: {

    },
    watch: {
        show: function(n, o) {
            var that = this;
            if (n) {
                that.province_name = that._province;
                that.province_id = that._provinceId;
                that.city_name = that._city;
                that.city_id = that._cityId;
                that.area_name = that._area;
                that.area_id = that._areaId;
                that.town_name = that._town;
                that.town_id = that._townId;
                if (that.province_id) {
                    that.getJdAreas(2, that.province_id);
                    if (that.city_id) {
                        that.getJdAreas(3, that.city_id);
                        if (that.area_id) {
                            that.getJdAreas(4, that.area_id);
                        }
                    }
                    that.showNext = 0;
                }
            }
        }
    },
    mounted() {
        let that = this;
        that.getJdAreas();
    }
}
</script>


// WEBPACK FOOTER //
// Jdcity.vue?6690f539